/* @flow */
import React from 'react';
import i18n from '@remind/i18n';

import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Copy from 'components/Copy.jsx';
import DialogButton from 'components/DialogButton.jsx';
import DialogContent from 'components/DialogContent.jsx';
import Link from 'components/Link.jsx';
import UnsubscribeActions from 'actions/UnsubscribeActions';

class MarketingEmailUnsubscribeView extends React.Component {
  state = {
    disabled: true,
    error: false,
    // $FlowFixMe
    unsubscribe: null,
    unsubscribeError: null,
    concluded: false,
  };

  componentDidMount() {
    const onSuccess = (unsubscribe) => {
      this.setState({
        disabled: false,
        unsubscribe,
      });
    };
    const onError = (response) => {
      this.setState({
        error: response.error,
      });
    };
    UnsubscribeActions
      .confirm(this.props.params.token)
      .then(onSuccess, onError);
  }

  handleUnsubscribeButtonClick = () => {
    this.setState({
      disabled: true,
    });

    if (!this.state.unsubscribe) {
      console.error('missing unsubscribe entity');
      return;
    }

    UnsubscribeActions.unsubscribe(this.state.unsubscribe)
      .then(() => {
        this.setState({
          concluded: true,
        });
      }, response => {
        this.setState({
          concluded: true,
          unsubscribeError: response.error,
        });
      }
    );
  };

  renderConclusion = () => {
    let title = i18n.getText('You are now unsubscribed.');
    let glyph = 'check';
    let color = 'shamrock';
    if (this.state.unsubscribeError) {
      title = this.state.unsubscribeError;
      glyph = 'caution';
      color = 'lava';
    }
    return (
      <DialogContent
        size="small"
        title={title}
        glyph={glyph}
        glyphColor={color}
      />
    );
  };

  renderConfirmation = () => {
    let title;
    if (this.state.unsubscribe) {
      // Maybe in the future put another message for when a person is already unsubscribed
      title = i18n.getText('Are you sure you want to unsubscribe from Remind marketing emails?');
    } else {
      title = this.state.error;
    }

    return (
      <DialogContent
        size="small"
        title={title}
        glyph="caution"
        glyphColor="lava">
        <BoxBody>
          {
            this.state.unsubscribe && (<Copy>
              <p>
                We understand—your inbox can get busy. Click on the button below to stop receiving marketing emails from Remind at {this.state.unsubscribe.getEmail()}.
                You’ll still receive messages from any classes you belong to.
              </p>
              <p>
                If you’d like to edit your contact information, change your notification preferences, or download the Remind app,{' '}
                <Link to="/settings/notifications">visit your account</Link>
                {' '}instead.
              </p>
            </Copy>)
          }
          <DialogButton
            onClick={this.handleUnsubscribeButtonClick}
            disabled={this.state.disabled}
            level="primary">
            {i18n.getText('Unsubscribe')}
          </DialogButton>
        </BoxBody>
        <BoxFooter>
          Click <Link to="/settings/notifications">here</Link> to edit message preferences
        </BoxFooter>
      </DialogContent>
    );
  };

  render() {
    if (this.state.concluded) {
      return this.renderConclusion();
    } else {
      return this.renderConfirmation();
    }
  }
}

export default MarketingEmailUnsubscribeView;



// WEBPACK FOOTER //
// ./src/user/components/MarketingEmailUnsubscribeView.jsx